<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 md3>
        <v-navigation-drawer permanent light width="100%" class="mavSmallMenu">
          <v-toolbar flat>
            <v-list>
              <v-list-tile>
                <v-list-tile-title class="title">
                  Travel Reports
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-toolbar>
          <v-divider></v-divider>
          <v-list>
            <template v-for="item in sideMenu">
              <v-list-tile :key="item.name" @click="$router.push({ name: item.name })" v-if="checkAccess([item.name])">
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action v-if="isMatchRoute(item.name)">
                  <v-icon color="primary">mdi-arrow-right-bold-hexagon-outline</v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list>
        </v-navigation-drawer>
      </v-flex>
      <v-flex xs12 md9>
        <transition name="slide-x-transition" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import clone from 'clone'
import routeMixin from '@/mixins/route'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      sideMenu: []
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  methods: {
  },
  beforeMount() {
    const menu = this.$store.getters.getInternalMenu('travelAgencyReports')
    if (menu && menu.children && menu.children.length > 0) {
      this.sideMenu = clone(menu.children)
    }
  },
  mixins: [
    routeMixin
  ]
}
</script>

<style>
</style>
